export default "__VITE_ASSET__$4iZdF63__"